import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Link, type LinkProps } from '#src/components/core/Link.tsx'

export type LinkCellProps = LinkProps

export function LinkCell({
  className,
  ...delegated
}: LinkCellProps): JSX.Element {
  return (
    <Link
      tabIndex={-1} // We don't want to have people tab through every cell.
      className={cn('-m-4 block cursor-pointer p-4', className)}
      {...delegated}
    />
  )
}
